import React from 'react';
import { BrowserRouter, StaticRouter, Route, Switch } from 'react-router-dom';
import Header from 'components/header/header';
import Footer from 'components/footer/footer';
import Home from 'components/home/Home';
import DynamicPage from 'components/content/DynamicPage';
import * as Common from 'components/common';
import helper from 'components/utils/helper';
import { CMSContext, ConfigContext } from './context/AppContext';
import { CmsLogin, CmsLogout, CmsPreview } from 'components/cms';
import { Helmet }  from "react-helmet";
import LiveChat from 'react-livechat';

const MoRouter = () => {
  let CmsContext = React.useContext(CMSContext);
  const [cms, setCms] = React.useState(CmsContext);
  let moConfig = React.useContext(ConfigContext);
  const [config, setConfig] = React.useState(moConfig);
  const configValue = {config, setConfig};
  const [loading, setLoading] = React.useState(true);
  const [randomKey, setRandomKey] = React.useState(Math.random());
  let routes = [];


  React.useEffect(() => {
    setAppLanguage();
    // Fetch cms json file
    fetchToCmsJson();

    // Event listeners
    window.addEventListener('changeCms', e => {
      if(e.detail && e.detail.cms){
        setCms(e.detail.cms);
      }
    });
    // for Cms Draft Preview
    // window.addEventListener('message', (event) => {
    //   if (event.data && typeof(event.data) === 'string') {
    //       let eventData = JSON.parse(event.data);
    //       renderPreview(eventData);
    //   }
    // });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[config]);

  React.useEffect(() => {
    // Make sure this cms 
    if(cms.preRenderUrl){
      // In index.html set root visibility to hidden to avoid Flash of Unstyled Content
      // Set root visibility back to visible here and start showing skeleton loading page
      let root = document.getElementById('root');
      root.style.visibility = 'visible';
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  },[cms]);

  // LiveChat
  React.useEffect (() => {
    // Event listener to disable/enable LiveChat in uat/production
    //Default
    if(helper.getEnvironment() === 'uat'){
      let hideChatInterval = setInterval(() => {
        if(document.getElementById('chat-widget-container')){
          hideLiveChat();
         clearInterval(hideChatInterval);
        }
      }, 500);
    }
    window.addEventListener('disableLiveChat', e => {
      if(e.detail && e.detail.env){
        switch(e.detail.env){
          default:
          case 'uat':
            if(helper.getEnvironment() === 'uat'){
              hideLiveChat(e.detail.disable);
            };
            break;
          case 'production':
            if(helper.getEnvironment() === 'produs'){
              hideLiveChat(e.detail.disable);
            };
            break;
          case 'local':
            if(helper.getEnvironment() === 'local'){
              hideLiveChat(e.detail.disable);
            };
            break;
        }
      }
    });
  }, [])

  function hideLiveChat(hide) {
    let liveChatContainer = document.getElementById('chat-widget-container');
    if(liveChatContainer){
      liveChatContainer.style.display = (hide === undefined || hide) ? 'none' : 'block';
      if(liveChatContainer.style.display === 'block'){
        liveChatContainer.style.width = '281px';
        liveChatContainer.style.height = '63px';
      }
    }
  }

  function fetchToCmsJson() {
    let url = helper.getAssetUrl('cms', config.getCountry(), config.getLanguage());
    setLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          combineCms(result);
        },
        (error) => {
          // Get local cms json
          combineCms(cms);
          console.log("Request error " + error);
        }
      );
  }

  function combineCms(cmsJson) {
    if(cmsJson && cmsJson.pages) {
      // let pages = { home: { url: "/", title: "Home" }};
      // pages = Object.assign(pages, cmsJson.pages);
      // cmsJson.pages = pages;
      setCms(cmsJson); 
    }
  }

  function setAppLanguage() {
    let {pathname, hostname} = window.location;

    // Country code
    if(hostname.charAt(2) === '.' && config.getCountry() !== hostname.substr(0,2)){
      let newCountryCode = hostname.substr(0,2);
      if(config.getValue(["locale", newCountryCode])){
        config.setCountry(newCountryCode);
      }
    }

    // Language code
    if((pathname.length <= 3  || pathname.charAt(3) === '/') && config.getLanguage() !== pathname.substr(1,2)){
      let newLanguageCode = pathname.substr(1,2);

      if(config.getValue(["locale", config.getCountry(), "language"])){
        for(let i=0; i < config.getValue(["locale", config.getCountry(), "language"]).length; i ++){
          if(config.getValue(["locale", config.getCountry(), "language", i]).code === newLanguageCode){
            config.setLanguage(newLanguageCode);
              break;
          }
        }
      }
    }

//    setConfig(config);
  }
  
  function renderPreview(json){
    let newCms = cms;
    for (let id in json){
      if (typeof newCms.components[id] === 'undefined') {
        newCms['pages']['stories']['components'].push(
          {
            "id": id,
            "title": json[id]['title'],
            "url": json[id]['url'],
            "components": [id]
          }
        )
      }
      newCms.components[id] = json[id];
    }
    setCms(newCms);
    // Need to re-render current page to see new changes.
    // Can NOT reload the page as it would retrieve the cms again
    // Generate new random key in Article route for re-rendering article page in react-router
    setRandomKey(Math.random());
  }

  return (
    <React.Fragment>
      {loading && <Common.Loading />}
      {!loading && renderRouter()}
    </React.Fragment>
  );

  function renderRouter(params) {
    let location = params && params.location ? params.location : "",
    RouterType = params && params.ssr ? StaticRouter : BrowserRouter;

    return (
      <ConfigContext.Provider value={configValue}>
        <CMSContext.Provider value={cms}>
          {/* Metadata */}
          {renderMetaTags()}
          <div id="clipboard-container"></div>
          {/* React Router */}
          <RouterType location={location}>
            <Header cms={cms}/>
            <CmsPreview/>
            <div id="content-container">
              <Switch>{getRoutes()}</Switch>
            </div>
          </RouterType>
          {/* Live chat */}
          {(config.getValue(["livechat.enabled"]).indexOf(config.getCountry()) > -1) &&
            <LiveChat license={config.getValue("livechat.licenseId")} />
          }
          <Footer cms={cms}/>
        </CMSContext.Provider>
      </ConfigContext.Provider>
    );
  }

  function renderMetaTags() {
    return (
      <React.Fragment>
        {/* React Helmet to manage meta tags in document head */}
        <Helmet>
          <meta name="application-name" content={cms.siteSettings.metadata.title} />
          <meta name="description" content={cms.siteSettings.metadata.description} />
          <link rel="icon" href={cms.siteSettings.metadata['fav-icon'].url} />
          <link rel="apple-touch-icon" href={cms.siteSettings.metadata['fav-icon'].url} />
          {/* Open Graph meta tags */}
          <meta property="og:url" content={window.location.href} />
          <meta property="og:locale" content={`${config.getLanguage()}_${config.getCountry()}`} />
          <meta property="og:title" content={cms.siteSettings.metadata.title}/>
          <meta property="og:type" content="website"/>
          <meta property="og:image" content="https://cdn.movember.com/uploads/images/Logos/Movember_Iconic%20Mo_Black.jpg" />
          <meta property="og:description" content={cms.siteSettings.metadata.description} />
        </Helmet>
      </React.Fragment>
    );
  }


  function getRoutes() {
    // Render Routes from static pages and dynamic pages from cms context
    for (const pageName in cms.pages) {
      let route = cms.pages[pageName];
      route.components && route.components.length > 0
        ? addDynamicPages(route, pageName)
        : addStaticPages(route, pageName);
    }
    // Add No-Match route (404)
    routes.push(
      <Route path="*" component={Common.NoRoute} key="no-route" />
    );
    return routes;
  }

  function addStaticPages(route, page) {
    let pageComponent = Home;
    switch (page) {
      default:
      case "home":
        pageComponent = Home;
        break;
      case "cms-login":
        pageComponent = CmsLogin;
        break;
      case "cms-logout":
        pageComponent = CmsLogout;
        break;
    }
    routes.push(
      <Route exact path={(config.getLanguage() !== 'en') ? `/${config.getLanguage() + route.url}` : route.url} component={pageComponent} key={page}></Route>
    );
  }

  function addDynamicPages(route, page) {
    if(route.url && route.url !== '/' && route.components){
      routes.push(
        <Route exact path={(config.getLanguage() !== 'en') ? `/${config.getLanguage() + route.url}` : route.url} key={page}>
          <DynamicPage
            cms={cms}
            page={page}
            componentList={route.components}
          />
        </Route>
      );
    }
   switch (page) {
     default:
     case "stories":
     case "content":
      addRoutes(route.components, page === 'stories' ? 'story' : page);
      break;
   }
 }

 function addRoutes(pages, pageName){
    pages.map(page => {
      // Temporary homepage
      let pageUrl = page.url === '/index' ? '/' : page.url;
      routes.push(
        // For Story, set randomKey to re-render this component to see changes on Preview
        <Route exact path={pageUrl} key={pageName === 'story' ? randomKey : page.id}>
          <DynamicPage
            cms={cms}
            page={pageName}
            content={page}
            componentList={page.components}
          />
        </Route>
      )}
    );
 }

};
 
export default MoRouter;
